import { SharedDealService } from "@js/services/Deal/SharedDealService";
import { DealClientClient, SecurityQuestionEnum } from "@src/apis/ModularClient";

export class DealSecurityCheckController {
  dateOfBirth: Date;
  email: string;
  phone: string;
  postcode: string;
  answers: number;
  error: boolean = false;

  securityValidation: ng.IFormController;
  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  uniqueId: string;
  showDob: boolean = false;
  showPhone: boolean = false;
  showPostCode: boolean = false;

  orgUniqueRef: string;
  brokerUserId: number;

  static $inject = ["$routeParams", "$location", "DealClientClient", "SharedDealService"];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private dealClientClient: DealClientClient,
    private sharedDealService: SharedDealService,
  ) {
    this.uniqueId = this.$routeParams.uniqueId;
    if (this.$routeParams.orgUniqueRef && this.$routeParams.brokerUserId) {
      this.orgUniqueRef = this.$routeParams.orgUniqueRef;
      this.brokerUserId = this.$routeParams.brokerUserId;
    }

    if (this.uniqueId) {
      this.dealClientClient.getShareholderEmailAndSecurityQuestions(this.uniqueId).then((response) => {
        this.email = response?.email;
        const securityQuestions = response?.securityQuestions;

        this.showDob = SecurityQuestionEnum.DateOfBirth === (securityQuestions & SecurityQuestionEnum.DateOfBirth);
        this.showPostCode = SecurityQuestionEnum.PostCode === (securityQuestions & SecurityQuestionEnum.PostCode);
        this.showPhone = SecurityQuestionEnum.PhoneNumber === (securityQuestions & SecurityQuestionEnum.PhoneNumber);
      });
    }
  }

  isValidAnswer() {
    this.answers = 0;

    if (this.dateOfBirth) {
      this.answers++;
    }

    if (this.phone) {
      this.answers++;
    }

    if (this.postcode) {
      this.answers++;
    }

    if (this.answers >= 2 && this.securityValidation.$valid && !this.securityValidation.$pristine) {
      return false;
    } else {
      return true;
    }
  }

  send() {
    if (this.uniqueId) {
      this.dealClientClient
        .securityCheck({
          uniqueId: this.uniqueId,
          phoneNumber: this.phone ? this.phone : null,
          postCode: this.postcode ? this.postcode : null,
          dateOfBirth: this.dateOfBirth ? this.sharedDealService.modifyDateForBackend(this.dateOfBirth) : null,
          orgUniqueRef: this.orgUniqueRef,
          brokerUserId: this.brokerUserId,
        })
        .then((i) => {
          const targeturl = this.$location.search().targeturl;

          if (targeturl) {
            this.$location.search({});
            this.$location.path(targeturl);
          } else {
            this.$location.path(i);
          }
        })
        .catch(() => {
          this.error = true;
        });
    }
  }
}
